// components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#22AAEE] text-white py-4">
      <div className="max-w-screen-lg mx-auto flex flex-col items-center text-center px-4">
        <div className="mb-4">
          <span className="text-sm">© 2025 Plutonic, Inc. All Rights Reserved.</span>
          <span className="mx-4">|</span>
          <a href="/terms" className="text-white underline hover:text-gray-200 text-sm">
            Terms and Conditions
          </a>
          <span className="mx-4">|</span>
          <a href="/privacy" className="text-white underline hover:text-gray-200 text-sm">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
